import { render, staticRenderFns } from "./LiveStageWaypointCaption.vue?vue&type=template&id=e6354c2c"
import script from "./LiveStageWaypointCaption.vue?vue&type=script&lang=js"
export * from "./LiveStageWaypointCaption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports